<template>
	<v-container>
		<v-card >
			<v-card-title
				class = "caption secondary justify-space-between pa-1 px-1 white--text"
				transition 	= "scroll-x-transition"	
			>
				<template 
					v-for = "(head_alert, idx_head_alert) of headers_alert"
				>	
					<span 
						v-if = "head_alert.type == 'info_icon'"
						:key = "idx_head_alert" 
					>							
						<v-icon
							
							small 
							:color = "head_alert.color"
							v-text = "head_alert.icon"
						></v-icon> 
						<span 
							class = "px-1 mr-2"
						>
							{{ head_alert.text ? 
								$ml.get(head_alert.text) + ':' : 
								'' }} 
							{{ info_head[head_alert.key] }} 
						</span>
					</span>
					<v-btn-toggle v-if  = "head_alert.type == 'btn'" >
						<template v-for = "(sub_head, idx_sub_head) of head_alert.btns">
							
							<v-tooltip bottom>
								<template v-slot:activator = "{ on }">
									<v-btn
										x-small
										:color = "sub_head.color"
										@click = "actions(sub_head.action)"
										v-on   = "on"
										:key   = "idx_sub_head"
										v-show = "sub_head.enable" 
									>
										<v-icon
											small
											v-text = "sub_head.icon"
											:color = "info_btn[sub_head.key] ? sub_head.color1 : sub_head.color2"						
										></v-icon>
									</v-btn>
								</template>
								<span>
									{{ sub_head.tooltip ? $ml.get(sub_head.tooltip) : '' }}
								</span>
								
							</v-tooltip>
						</template>
					</v-btn-toggle>
				</template>
			</v-card-title>
			<v-card-text class = "pa-0">
				<v-row dense>
					<template v-for="(item, idx) of renderInformations">						
						<v-col
							:cols = "item.typeCol"
							:md   = "item.typeColMd"
							:key  = "ID_notification + idx + item.component"
						>
							<component
								:is 				= "item.component"
								:info_to_component 	= "item.content"		
								:key  				= " idx  + ID_notification + item.component"

							></component>
						</v-col>
					</template>
				</v-row>
				
			</v-card-text>
		</v-card>
	</v-container>
</template>
<script type="text/javascript">

	import basicInformation from "@/components/info/basicInformation";
	import videoInformation from "@/components/info/videoInformation";
	import mapInformation 	from "@/components/info/mapInformation";	
	import actionTest  		from "@/components/info/test/actionsTest.js"
	import faceTest  		from "@/components/info/test/faceTest.js"
	import smart_eventTest	from "@/components/info/test/smart_eventTest.js"
	import alarmTest  		from "@/components/info/test/alarmTest.js"


	export default{
		name : "evidence_info",
		components: {
			basicInformation,
			videoInformation,
			mapInformation
		},
		data : (vm)=>({
			info 			: null,
			info_head 		: {
				date  	 : vm.$Format.format_date(new Date(),"createdAt"),
				tag 	 : 'tag',
			},
			loading 	: false,
			ID_notification : "evidenenceInfo",
			headers_alert	: [{
					type 	: 'info_icon',
					enable 	: true,
					text 	: '', // date
					key  	: 'date',
					color 	: 'white', 
					icon 	: 'mdi-calendar'
				},
				{
					type 	: 'info_icon',
					enable 	: true,
					text 	: '',//tag
					key  	: 'tag',
					color 	: 'primary', // info 
					icon 	: 'mdi-label' // format-list-bulleted // crosshairs //  tag // marker-check // focus-field / horizontal // image-filter-center-focus / weak
				},
			],
		}), // data
		created(){
			if (this.$route) {
				const { type, id } = this.$route.params;
				this.get_list(id, type);
			}
			 
		}, // created
		computed: {
			renderInformations: function(){
				return this.info;
			}
		}, // 
		methods : {
			get_list(id, type){
				let url 	 = this.$URL;
				this.loading = true; 
				if (type == "alarms") { url += `/api/v1/alerts/${id}`;
				}else if (type == "smart_event") { url += `/api/v1/smart_event/${id}`
				}else if (type == "face") { url += `/api/v1/face/report/${id}`
				}else if (type == "lpr") { url += `/api/v1/lpr/${id}`
				}else if (type == "actions") {url += `/api/v1/actions/${id}`}
				this.$axios.get(url).then(res =>{
					if (res && res.data) {
						this.renderInfo(this.$Format.format_info(res.data, type));
					}else{
						this.$EventBus.$emit("notifications_modal",{
							type 	: "warning",
							message : this.$ml.get("not_found")
						});
					}
					this.loading = false; 

				}).catch(err => {
					console.warn("Error get evidenence info ", err);
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : err
					});
					this.loading = false; 
					if (type == "alarms") {						
						this.renderInfo(this.$Format.format_info(alarmTest, type));
						/*this.$Format.report_export_excel("alarms", [alarmTest], null, this.$Format , (load)=>{
							if (load && load.length > 0) {
								console.log("LOAD ======== ", load, alarmTest)
				       			this.$Format.export_excel(load, "alarms");
				       		}
						}) */
					}else if (type == "smart_event") {
						this.renderInfo(this.$Format.format_info(smart_eventTest, type));
					}else if (type == "face") {
						this.renderInfo(this.$Format.format_info(lprTest, type));
					}else if (type == "lpr") {
						// this.renderInfo(this.$Format.format_info(lprTest, type));
					}else if (type == "actions") {
						this.renderInfo(this.$Format.format_info(actionTest, type));
					}


				})
			}, // get list
			renderInfo(item){
					if (item && item.formated) {
						// console.log("evidenence ", item)
						const check_del 	 = ['videos', 'tag', 'date', 'bbox', 'analytic', 'table'];
						const { content, content1, content2, videos, locations } = {...item.formated};
						const constructed = {
							basic 		: { 
								component : "basicInformation", 
								typeCol : "12",
								typeColMd : "6",
								content : {...content}, 
							},
							
						}; 
						for (let it in content){
							if (check_del.includes(it)) {							
								delete constructed.basic.content[it];
							}
						}

						if (item.head) {							
							this.info_head  					= item.head;	

						}else{
							this.info_head = {
								tag  		: item.formated.content.tag,
								date 		: item.formated.content.date,
								prediction 	: item.formated.content.prediction,
							}
						}

						if (content1) {
							constructed.basic1 		= { 
								component : "basicInformation", 
								typeCol : "12",
								typeColMd : "6",
								content : {...content1}, 
							};
						}
						if (content2) {
							constructed.basic2 = { 
								component : "basicInformation", 
								typeCol : "12",
								typeColMd : "6",
								content : {...content2}, 
							};
						}
						if (locations && locations.length > 0) {
							constructed.location = { 
								component : "mapInformation", 
								typeCol : "12",
								typeColMd : "6",
								content : [...locations],
								/*[
								    {
								        "latitude": "10.995280180873745",
								        "longitude": "-74.80479656654909",
								        "name": "camLPR",
								        "deviceId": "a20db1b1-468c-42d7-9945-09a9e2be33f5"
								    }
								]*/// 
							};
						}
						if (videos && videos.length > 0) {
							this.renderVideos(videos);
						}else{
							const {date, deviceId} = this.info_head;
							this.getVideos(date, deviceId);
						}									
						console.log("contructed ", constructed, this.info_head);
						this.info = {...constructed};
					}	

			}, // renderInfo
			renderVideos(videos){
				if (videos && videos.length > 0) {

					this.info.video = { 
						component : "videoInformation", 
						typeCol : "12",
						typeColMd : "6",							
						content : {
							videos 	 	: [...videos],
							info_search : {...this.info_head},
							
						}, 
					};
				}
			}, // renderVideos
			getVideos(date, deviceId){
				if(date){
					let dates = this.$Format.format_date_to_dates_seg(date, 300000, 'subtract');
					console.log("dates : ", dates);
					let search = {
						timeZone : this.$timezone, 
						start 	 : dates[0],
						end 	 : dates[1],
						deviceId
					};
					const api = this.$URL + "/api/v1/records/find/video";
					this.$axios.post(api, search).then( res => {
						if (res && res.data && res.data.rows && res.data.rows.length > 0) {
							let items 	 = res.data.rows, 
								new_list = [];
							for (let i = 0; i < items.length; i++) {
								if(items[i].urlpath){									
									new_list.push(this.$URL + items[i].urlpath);								
								}
							}						
							if (new_list.length > 0) {								
								this.renderVideos(new_list);						
							}
						}
					}).catch(er => {
						console.log("er get video : ", er);					
					}) 
				}
			}, // get videos
		}, // methods
	};
</script>

<!-- 

	{ 
		content 	: info_to_component,
			info_to_component => {		
				images   : [ 
					{ 
						img : vm.$EXT + '/img/no_img_found.png'
					} 
				],
				device 	 : 'host1',
				date  	 : vm.$momentz(new Date()),
				tag 	 : 'gun',
			}
		component 	: "basicInformation"
		colMd 		:  6 | 4 | 3 // windows mediums  
		cols 		:  12 		 // windows phones
	}


 -->	
